import { Link } from "react-router-dom";
import { BookOpen, Heart, Eye, Clock, Hash } from "lucide-react";
import { VerifiedBadge } from "./VerifiedBadge";

export default function StoryCard({ story, index = 0 }) {
  return (
    <Link
      to={`/stories/${story.id}`}
      data-testid={`story-card-${story.id}`}
      className="group block rounded-2xl bg-[#0A0A0A] border border-white/[0.06] p-5 shadow-[0_10px_30px_-14px_rgba(0,0,0,0.9)] hover:border-[#00E5FF]/40 hover:shadow-[0_18px_44px_-16px_rgba(0,229,255,0.28)] hover:-translate-y-1 transition-[transform,box-shadow,border-color] duration-300 fade-up"
      style={{ animationDelay: `${Math.min(index * 0.04, 0.4)}s` }}
    >
      <div className="flex items-center gap-2 mb-3">
        <span className="w-9 h-9 rounded-xl flex items-center justify-center bg-[#00E5FF]/12 border border-[#00E5FF]/25 shrink-0">
          <BookOpen size={17} className="text-[#00E5FF]" />
        </span>
        {story.category && (
          <span className="text-[10px] font-mono uppercase tracking-wider text-[#00E5FF] bg-[#00E5FF]/10 border border-[#00E5FF]/25 px-2 py-0.5 rounded-full truncate">
            {story.category}
          </span>
        )}
        {story.status === "review" && (
          <span data-testid={`story-review-badge-${story.id}`} className="text-[10px] font-mono uppercase tracking-wider text-[#F1A817] bg-[#F1A817]/10 border border-[#F1A817]/30 px-2 py-0.5 rounded-full">
            In review
          </span>
        )}
      </div>

      <h3 className="text-white font-heading uppercase tracking-tight text-lg leading-tight line-clamp-2 group-hover:text-[#00E5FF] transition-colors">
        {story.title}
      </h3>
      <p className="text-[#A1A1AA] text-sm mt-2 line-clamp-3 leading-relaxed">{story.summary || "No summary yet."}</p>

      {story.tags?.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-3">
          {story.tags.slice(0, 4).map((t) => (
            <span key={t} className="flex items-center gap-0.5 text-[10px] text-[#8A8D91] bg-white/[0.04] border border-white/[0.06] px-2 py-0.5 rounded-full">
              <Hash size={9} className="text-[#4599FF]" />{t}
            </span>
          ))}
        </div>
      )}

      <div className="flex items-center gap-4 mt-4 pt-3 border-t border-white/[0.05] text-[#52525B] font-mono text-[11px]">
        <span className="flex flex-col leading-tight min-w-0">
          <span className="text-white/85 font-sans text-xs font-semibold flex items-center gap-1 min-w-0"><span className="truncate">{story.author_display_name || story.author_username}</span><VerifiedBadge show={story.author_verified} size={12} testId={`story-verified-${story.id}`} /></span>
          <span className="text-[#8A8D91] truncate">@{story.author_username}</span>
        </span>
        <span className="flex items-center gap-1"><Clock size={12} /> {story.reading_minutes} min</span>
        <span className="flex items-center gap-1"><Heart size={12} /> {story.likes_count}</span>
        <span className="flex items-center gap-1"><Eye size={12} /> {story.views}</span>
      </div>
    </Link>
  );
}
